import typeCheck from 'common/util/typeCheck';

import log from 'client/lib/log';

export const SR_MOBILE_APP_ACTION_TYPE_ROUTE_CHANGED = 'SR_MOBILE_APP_ACTION_TYPE_ROUTE_CHANGED';
export const SR_MOBILE_APP_ACTION_TYPE_OPEN_URL = 'SR_MOBILE_APP_ACTION_TYPE_OPEN_URL';
export const SR_MOBILE_APP_ACTION_TYPE_REQUEST_PUSH_NOTIFICATION_PERMISSION =
  'SR_MOBILE_APP_ACTION_TYPE_REQUEST_PUSH_NOTIFICATION_PERMISSION'; // eslint-disable-line max-len
export const SR_MOBILE_APP_ACTION_TYPE_LOGOUT = 'SR_MOBILE_APP_ACTION_TYPE_LOGOUT';
export const SR_MOBILE_APP_ACTION_TYPE_RATE_APP = 'SR_MOBILE_APP_ACTION_TYPE_RATE_APP';
export const SR_MOBILE_APP_ACTION_TYPE_CURRENT_USER = 'SR_MOBILE_APP_ACTION_TYPE_CURRENT_USER';
export const SR_MOBILE_APP_ACTION_TYPE_GET_CURRENT_LOCATION =
  'SR_MOBILE_APP_ACTION_TYPE_GET_CURRENT_LOCATION'; // eslint-disable-line max-len
export const SR_MOBILE_APP_ACTION_TYPE_ID_VERIFICATION =
  'SR_MOBILE_APP_ACTION_TYPE_ID_VERIFICATION';

const debug = log.debug('sunroom:helpers:sendDataToMobileApp');

export default function sendDataToMobileApp(data) {
  typeCheck('data::NonEmptyObject', data);
  typeCheck('actionType::NonEmptyString', data.actionType);

  if (data.actionType === SR_MOBILE_APP_ACTION_TYPE_ROUTE_CHANGED) {
    typeCheck('routePath::NonEmptyString', data.routePath);
    typeCheck('currentUser::NonEmptyObject', data.currentUser);
  }
  if (data.actionType === SR_MOBILE_APP_ACTION_TYPE_CURRENT_USER) {
    typeCheck('currentUser::NonEmptyObject', data.currentUser);
  }
  if (data.actionType === SR_MOBILE_APP_ACTION_TYPE_OPEN_URL) {
    typeCheck('url::NonEmptyString', data.url);
  }

  try {
    const dataToString = JSON.stringify(data);
    debug('data', data);
    if (global.ReactNativeWebView) {
      global.ReactNativeWebView.postMessage(dataToString);
    }
  } catch (error) {
    log.error(error);
  }
}
